import { render, staticRenderFns } from "./FilterSorting.vue?vue&type=template&id=aa7002fa&"
import script from "./FilterSorting.vue?vue&type=script&lang=ts&"
export * from "./FilterSorting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports